import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { FaqService } from 'src/app/services/faq.service';
import { OverlayService } from 'src/app/services/overlay.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {
  /**
   * The Columns to be shown
   */
  displayedColumns = ['number', 'question', 'answer', 'menu'];
  /**
   * The data to be shown
   */
  dataSource: MatTableDataSource<any>;
  /**
   * show the Entries as Accordition
   */
  showAsAccordition: boolean = false;
  /**
   * constructor
   * @param faq 
   * @param overlay 
   */
  constructor(
    private faq: FaqService,
    private overlay: OverlayService) {

     }
  /**
   * ngOnInit
   * get all FAQs
   */
  ngOnInit() {
    this.faq.getFAQs().subscribe(faq => {
      let temp = [];
      faq.forEach(FAQelement => {
        temp.push({
          description: FAQelement.description,
          title: FAQelement.title,
          publicId: FAQelement.publicId
        })
      });
      this.dataSource = new MatTableDataSource(temp);
    })
  }
  /**
   * Delte a FAQ-Entry
   * @param faq 
   */
  deleteFaq(faq) {
    this.faq.deleteFAQ(faq).subscribe(fromDelte => {
      this.overlay.openSnackBar("FAQ-Eintrag erfolgreich gelöscht!");
      this.faq.getFAQs().subscribe(faq => {
        this.dataSource = new MatTableDataSource(faq);
      })
    })
  }

  /**
   * Change the type the FAQ are shown
   * @param type 
   */
  toggleAccordition(type: string) {
    if (type == 'accordition') {
      this.showAsAccordition = true;
    }
    if (type == 'table') {
      this.showAsAccordition = false
    }
  }
}
